<template>
  <Row :gutter="16">
    <Col :span="12">
      <study-info :model="model"></study-info>
    </Col>
    <Col :span="12">
      <study-sites :model="model"></study-sites>
    </Col>
  </Row>
</template>

<script>
import { ViewStudy } from '@/api/study'
import StudyInfo from '@/components/study/StudyInfo'
import Sites from '@/components/study/Sites'

export default {
  name: 'study-survery',
  data: () => ({
    model: null
  }),
  watch: {
    $route (to, from) {
      this.fetchData()
    }
  },
  created: function () {
    this.fetchData()
  },
  components: {
    'study-info': StudyInfo,
    'study-sites': Sites
  },
  methods: {
    fetchData: function () {
      const id = this.$route.params.id
      ViewStudy(id).then(async res => {
        this.model = res
      })
    }
  }
}
</script>
